import { css } from '@emotion/react';
import { ReactElement, useCallback } from 'react';
import { IS_IE } from 'sdk';

import { styledWithoutTheme } from '../../../../../styled';
import type { Theme } from '../../../../../theme/interface/detailed';
import { useTheme } from '../../../../../theme/useTheme';

type Interface = { className?: string; onClick: VoidFunction; disabled?: boolean };

const styles = css`
	text-align: center;
	display: flex;
	justify-content: center;
	align-items: center;
	box-sizing: border-box;
`;

const Component = ({ className, onClick, disabled }: Interface): ReactElement => {
	const theme = useTheme();
	const onClickHandler = useCallback(() => {
		if (!disabled) {
			onClick();
		}
	}, [disabled, onClick]);

	return (
		<button onClick={onClickHandler} tabIndex={0} className={className}>
			<svg
				width={theme.chat.buttons.messageSendIcon.width}
				height={theme.chat.buttons.messageSendIcon.height}
				viewBox="0 0 15 16"
				fill={theme.chat.buttons.messageSendIcon.backgroundColor}
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M14.6688 7.48076L0.812066 0.623786C0.575501 0.51636 0.293222 0.580359 0.128654 0.783782C-0.0370557 0.987206 -0.0427699 1.27634 0.114941 1.48548L4.00054 7.99961L0.114941 14.5137C-0.0427699 14.7229 -0.0370558 15.0131 0.127512 15.2154C0.238366 15.3537 0.404076 15.428 0.572072 15.428C0.653213 15.428 0.734354 15.4109 0.810924 15.3754L14.6677 8.51845C14.8711 8.42474 15.0003 8.22246 15.0003 7.99961C15.0003 7.77675 14.8711 7.57447 14.6688 7.48076Z"
					fill={theme.chat.buttons.messageSendIcon.color}
				/>
			</svg>
		</button>
	);
};

const MessageSendIcon = styledWithoutTheme(Component)(
	({
		theme: {
			chat: {
				buttons: {
					messageSendIcon: { width, height, outline, ...other },
				},
			},
		},
		disabled,
	}: {
		theme: Theme;
		disabled?: boolean;
	}) => ({
		width: IS_IE ? 'auto' : width,
		height: IS_IE ? 'auto' : height,
		backgroundColor: '#afb3c0',
		opacity: disabled ? 0.6 : 1,
		cursor: disabled ? 'default' : 'pointer',
		'&:focus': {
			outline,
		},
		...other,
	}),
	styles
);

export { MessageSendIcon };
